// ══════════════════════════════════════════════════════
//  extractors/marketVolume.js — 全市场 24h 交易数据
//
//  源：CoinGecko /coins/{id}?tickers=true 聚合（CEX + DEX 全市场）
//
//  跟 protocolFundamentals（永续合约）分开 —— 这个是 spot + DEX 的全市场
//  量，给「这个 token 流动性 / 主要交易场所」做信号。
// ══════════════════════════════════════════════════════

import { safeNum } from './_shared';

export function isAvailable(project) {
  return !!project?.marketVolume?.totalVolume;
}

export function extract(project) {
  const mv = project?.marketVolume;
  if (!mv?.totalVolume) return null;

  return {
    totalVolume:    safeNum(mv.totalVolume),
    binanceVolume:  safeNum(mv.binanceVolume),
    binanceShare:   safeNum(mv.binanceShare),
    cexTotal:       safeNum(mv.cexTotal),
    dexTotal:       safeNum(mv.dexTotal),
    cexShare:       safeNum(mv.cexShare),
    tickerCount:    safeNum(mv.tickerCount),
    topExchanges:   Array.isArray(mv.topExchanges) ? mv.topExchanges.slice(0, 5) : [],
  };
}
